import RestBase from '@/services/base/RestBase'
import { ApiEnum } from '@/constants/ApiEnum'

export default class EstudanteService extends RestBase {
    constructor() {
        super(ApiEnum.BACKEND, '', 2);
    }
    
    async getTipoDocumento() {
        return this.get(`/documento/tipoDocumento`);
    }

    async putDocumento(documento) {
        return this.put(`/documento/dependente`, documento);
    }

    async getDocumentosDependente(documentoId) {
        return this.get(`/documento/dependente/${documentoId}`);
    }
}